import React from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

function fmtDate(iso) {
  if (!iso) return "";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return s;
  return `${m}/${d}/${y}`;
}

export default function ConfirmAutocloseDialog({ open, onOpenChange, conflicts, onConfirm }) {
  const list = Array.isArray(conflicts) ? conflicts : [];

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="glass border-white/10" data-testid="commission-autoclose-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="commission-autoclose-title">Commission Profile Overlap</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-200/70" data-testid="commission-autoclose-description">
            A matching commission profile already exists for the same Company, Product, and Sales Agent.
            If you proceed, the existing profile(s) will be auto-closed.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="space-y-2 rounded-xl bg-white/5 p-3 ring-1 ring-white/10" data-testid="commission-autoclose-conflicts">
          {list.map((c) => (
            <div key={c.existing_profile_id} className="text-sm text-slate-100">
              <div className="font-semibold">Existing Profile</div>
              <div className="text-slate-200/80">
                Profile Dates: {fmtDate(c.existing_effective_start_date)}
                {c.existing_effective_end_date ? ` to ${fmtDate(c.existing_effective_end_date)}` : " (open-ended)"}
              </div>
              <div className="text-slate-200/80">
                Profile End Date will be set to: {fmtDate(c.auto_close_end_date)}
              </div>
            </div>
          ))}
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel
            className="rounded-full bg-white/10 text-slate-100 hover:bg-white/15"
            data-testid="commission-autoclose-cancel"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            className="rounded-full bg-indigo-500/30 text-indigo-100 ring-1 ring-indigo-400/20 hover:bg-indigo-500/40"
            onClick={onConfirm}
            data-testid="commission-autoclose-confirm"
          >
            Proceed & Auto-close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
